export default __webpack_public_path__ + "static/media/crew-08-bit.6801d26a.svg";